'use client'

import * as React from 'react'
import { useIsUserBanned } from '@repo/cf-user/hooks/use-user-data'
import { usePathname } from 'next/navigation'

export function UserBanCheck() {
  const isUserBanned = useIsUserBanned()
  const pathname = usePathname()

  React.useEffect(() => {
    if (isUserBanned && pathname !== '/access-blocked/') {
      window.location.href = '/access-blocked/'
    }
  }, [isUserBanned, pathname])

  return null
}
